const tabsData = [
    {
        label: 'Офисы',
        slotName: 'office',
    },
    {
        label: 'Банкоматы',
        slotName: 'atm',
    },
    {
        label: 'Терминалы',
        slotName: 'terminal',
    },
];

const servicesMap = {
    office: {
        // service_change: 'Обмен валюты',
        service_deposit: 'Вклады',
        service_pays: 'Прием платежей',
        service_cards: 'Пластиковые карты',
        service_p_v_n: 'Пункт выдачи наличных',
        service_depositary: 'Депозитарий',
        service_o_p_e_r_u: 'Расчетно-кассовое обслуживание',
        service_loanindiv: 'Кредитование частных лиц',
        service_corploan: 'Кредитование юридических лиц',
        // service_vip: 'Вип зал',
        service_weekends: 'Работает в выходные',
        service_has_rampant: 'Доступен для людей с ограниченными возможностями',
        service_bio_data_collection: 'Сбор биометрических данных',
        service_cards_ufk: 'Карты УФК',
    },
    atm: {
        around_the_clock: 'Круглосуточно',
        cashin_capable: 'Прием наличных',
        self_collection: 'Самоинкассация',
        foreign_currency: 'Выдача иностранной валюты',
    },
    terminal: {
        around_the_clock: 'Круглосуточно',
        transport_card: 'Пополнение транспортной карты',
    },
};

const unavailableRemoteOffices = {
    tuapse: 'da6d8960-a513-11e7-b635-628caf01d019',
};

export {
    tabsData,
    servicesMap,
    unavailableRemoteOffices,
};
